declare global {
    interface ObjectConstructor {
        keys<T>(o: T): number extends keyof T ? string[] : (keyof T)[];
        entries<T>(o: T): number extends keyof T ? [string, T[keyof T]][] : [keyof T, T[keyof T]][];
    }

    interface Uint8ArrayConstructor {
        fromBase64(base64: string, options?: { alphabet?: "base64" | "base64url", lastChunkHandling?: "loose" | "strict" | "stop-before-partial" }): Uint8Array;
    }

    type CredentialType = PasswordCredential | FederatedCredential | PublicKeyCredential;
    type CredentialBodyType = FormData | URLSearchParams;

    interface PasswordCredentialData {
        id: string;
        password: string;
        name?: string;
        iconURL?: string;
    }

    interface PasswordCredential extends Credential {
        readonly type: 'password';
        readonly password?: string;
        readonly name: string | null;
        readonly iconURL: string | null;
    }

    interface FederatedCredentialData {
        id: string;
        provider: string;
        protocol?: string;
        name?: string;
        iconURL?: string;
    }

    interface FederatedCredential extends Credential {
        readonly type: 'federated';
        readonly provider: string;
        readonly protocol: string | null;
        readonly name: string | null;
        readonly iconURL: string | null;
    }

    interface CredentialRequestOptions {
        password?: boolean;
        federated?: FederatedCredentialRequestOptions;
        unmediated?: boolean;
    }

    type PasswordCredentialInit = PasswordCredentialData | HTMLFormElement;
    type FederatedCredentialInit = FederatedCredentialData;

    interface CredentialCreationOptions {
        password?: PasswordCredentialData;
        federated?: FederatedCredentialInit;
        publicKey?: PublicKeyCredentialCreationOptions;
        signal?: AbortSignal;
    }

    interface FederatedCredentialRequestOptions {
        providers?: string[];
        protocols?: string[];
    }

    const PasswordCredential: {
        prototype: PasswordCredential;
        new(data: PasswordCredentialData): PasswordCredential;
    } | undefined;

    const FederatedCredential: {
        prototype: FederatedCredential;
        new(data: FederatedCredentialData): FederatedCredential;
    } | undefined;

    interface EyeDropper {
        open(): Promise<{ sRGBHex: string }>;
    }

    interface Window {
        EyeDropper: {
            prototype: EyeDropper;
            new(): EyeDropper;
        } | undefined;
    }
}

if(!Object.groupBy) {
    Object.groupBy = function <K extends PropertyKey, T>(items: Iterable<T>, keyFn: (item: T, index: number) => K): Partial<Record<K, T[]>> {
        const result: Partial<Record<K, T[]>> = {};
        let index = 0;

        for(const item of items) {
            const key = keyFn(item, index++);
            if(!result[key])
                result[key] = [];
            result[key]!.push(item);
        }

        return result;
    };
}


